import {Box, Divider, Typography} from "@mui/material";

// updated
export default function PageHeader(props: { title: string, action?: JSX.Element }) {

    return <Box sx={{mb: 2}}>

        <Box sx={{display: 'flex', alignItems: 'end', pb: 1.5, minHeight: 50}}>

            <Typography color='text.primary'
                        fontSize='medium'
                        sx={{flexGrow: 1}}>
                {props.title}
            </Typography>

            {
                props.action
            }

        </Box>

        <Divider/>

    </Box>


}
